import toast from 'react-hot-toast';

const MealDelete = async (id, setRefresh, type, userid, apiGlobal) => {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('type', type);
    formData.append('user_id', userid);

    try {
        const deletemealUrl = `${apiGlobal}/meal_delete.php`;
        // console.log(`Fetching URL: ${deletemealUrl}`);
        
        const deletemealUrlResponse = await fetch(deletemealUrl, {
            method: 'POST',
            body: formData,
        });

        if (!deletemealUrlResponse.ok) {
            throw new Error(`HTTP error! Status: ${deletemealUrlResponse.status}`);
        }

        const deletemealResponse = await deletemealUrlResponse.json();
        // console.log(deletemealResponse); 

        if (deletemealResponse.status && deletemealResponse.message === 'Meal record deleted successfully') {
            toast.success('Meal deleted successfully');
            setRefresh(prev => !prev);
        } else {
            toast.error(deletemealResponse.message);
        }
    } catch (error) {
        console.error('Error occurred during meal deletion:', error);
        toast.error(`Failed to delete: ${error.message}`);
    }
};

export default MealDelete;

